import { render } from "./Select.vue?vue&type=template&id=f10083e4"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v3/Select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f10083e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f10083e4', __exports__)) {
    api.reload('f10083e4', __exports__)
  }
  
  module.hot.accept("./Select.vue?vue&type=template&id=f10083e4", () => {
    api.rerender('f10083e4', render)
  })

}


export default __exports__